import React from 'react'
import PropTypes from 'prop-types'

export default function ModalContent({ children, ...restProps }) {
  return (
    <div className="papui_modal__content" data-testid="modal-content" {...restProps}>
      {children}
    </div>
  )
}

ModalContent.propTypes = {
  children: PropTypes.any,
}
